import React from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';

const ClinicProductsTableHeader = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell width="40%">Product</TableCell>
        <TableCell>Retail Price</TableCell>
        <TableCell>Clinic Fee</TableCell>
        <TableCell>Healthera Fee</TableCell>
        <TableCell>Pharmacy Fee</TableCell>
        <TableCell>Course Length</TableCell>
        <TableCell>Promotion</TableCell>
        <TableCell>Price per Usage</TableCell>
        <TableCell>Fixed Cycle</TableCell>
        <TableCell>Cycle Length</TableCell>
        <TableCell>Active</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default ClinicProductsTableHeader;
